<template>
  <div class="hdcmpr_v2">
    <p class="hdcmpr_title">
      <span class="protext">专业级</span>远控，练就过硬功底
    </p>
    <div class="tabs_box">
      <div
        v-for="(item, index) in tabsList" :class="[`tabs_box_${index + 1}`, index + 1 == currIdx ? 'active' : '']"
        @click="chooseTabs(index + 1)" :key="item"
      >
        {{ item }}
      </div>
      <div class="tabs_box_bg" :style="tabStyle"></div>
    </div>
    <div v-show="currIdx === 1" class="performance_wrap">
      <p class="hdcmpr_subtitle">{{ performanceDetails.title }}</p>
      <img class="bg_Img" :src="performanceDetails.bgImg" alt="">
      <div class="fun_list_wrap">
        <p v-for="item in performanceDetails.funList" class="fun_item" :key="item">
          <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8.5" cy="8.5332" r="8" stroke="#0070F9"/>
            <path d="M12.867 6.78714L12.804 6.85764L7.46751 12.0746C7.20699 12.3333 6.79244 12.3513 6.51051 12.1161L6.44301 12.0531L3.71301 9.16314C3.43924 8.87041 3.42807 8.41906 3.68701 8.11314C3.93924 7.81154 4.38811 7.77127 4.69001 8.02314L4.75901 8.08764L6.98601 10.4451L11.8 5.74064C11.9394 5.60199 12.1299 5.52707 12.3265 5.5336C12.523 5.54013 12.7081 5.62753 12.838 5.77514C13.0907 6.06069 13.1031 6.48685 12.867 6.78714Z" fill="#0070F9"/>
          </svg>
          {{ item }}
        </p>
      </div>
      <router-link to="/download" class="dl_btn">立即下载</router-link>
    </div>
    <div
      v-show="currIdx === 2"
      class="security_wrap"
      v-touch:swipe.left="touchLeft"
      v-touch:swipe.right="touchRight"
    >
      <div v-for="(item, index) in securityDetails" :class="['security_item', currSecurityIdx === index + 1 ? 'active' : '']" :key="item.funDesc">
        <p class="item_title">{{ item.title }}</p>
        <p class="item_subTitle">{{ item.subTitle }}</p>
        <div class="item_bg_wrap">
          <img class="bg_Img" :src="item.bgImg" alt="">
        </div>
        <p class="item_desc">{{ item.funDesc }}</p>
      </div>
      <div class="security_wrap_indicator">
        <i v-for="(indicator, index) in securityDetails" :class="['indicator_item', currSecurityIdx === index + 1 ? 'active' : '']" :key="indicator.bgImg"></i>
      </div>
      <div class="btn_wrap">
        <router-link to="/download" class="toc_dl">个人版下载</router-link>
        <a href="https://console.todesk.com/#/register" class="tob_register">企业版注册</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hdcmpr-v2",
  data() {
    return {
      currIdx: 1,
      currSecurityIdx: 1,
      tabsList: ['极致性能', 'ANPAD安全体系'],
      performanceDetails: {
        title: '画质更极致，无感低延迟',
        bgImg: 'https://todeskcdnspeed.todesk.com/20231019100344608082a65ee05c.png',
        funList: [
          '4K高清画面，不丢失设计细节',
          '0.04秒无感延时，鼠标指哪儿打哪儿',
          '兼容8192级数位板，坐标压感都精准',
          '支持蓝牙外设，鼠标键盘完美映射'
        ]
      },
      securityDetails: [
        {
          title: '架构安全',
          subTitle: '（"A"：Architecture Security）',
          bgImg: 'https://todeskcdnspeed.todesk.com/20230907111515604bc44d7aece8.png',
          funDesc: '系统方案的结构牢固、运行逻辑清晰，能够与公司原有安全体系紧密配合，经受住潜在的攻击',
        },
        {
          title: '网络安全',
          subTitle: '（"N"：Network Security）',
          bgImg: 'https://todeskcdnspeed.todesk.com/20230907111456604bc43b5c8828.png',
          funDesc: '对企业内网系统和传输过程进行保护，确保传输内容保密防盗，并且能识别、阻断恶意访问',
        },
        {
          title: '过程安全',
          subTitle: '（"P"：Process Security）',
          bgImg: 'https://todeskcdnspeed.todesk.com/20230907111437604bc4298fa330.png',
          funDesc: '在远程访问过程中对访问者身份进行验证，并对违规操作、文件转移等人为风险进行管控',
        },
        {
          title: '管理安全',
          subTitle: '（"A"：Administration Security）',
          bgImg: 'https://todeskcdnspeed.todesk.com/20230907111427604bc41f707028.png',
          funDesc: '在公司管理层面对远程访问的相关设备和人员进行管控，具备完善的远程访问管理制度和流程规范',
        },
        {
          title: '数据安全',
          subTitle: '（"D"：Data Security）',
          bgImg: 'https://todeskcdnspeed.todesk.com/20230907111413604bc412ae7c68.png',
          funDesc: '确保业务数据、代码、模型、算法等核心数字资产不被窃取、破坏、恶意加密',
        },
      ]
    };
  },
  computed: {
		tabStyle() {
			switch (this.currIdx) {
				case 1:
					return `left: ${0 / 375 * 100}vw; width:${102 / 375 * 100}vw;`
				case 2:
					return `left: ${126 / 375 * 100}vw; width:${126 / 375 * 100}vw;`
				default:
					return ''
			}
		}
	},
  mounted() {},
  beforeDestroy() {},
  methods: {
    chooseTabs(index = 1) {
      this.currIdx = index
    },
    touchLeft() {
			if(this.currSecurityIdx == this.securityDetails.length){
        this.currSecurityIdx = 1;
      }else{
        this.currSecurityIdx ++
      }
		},
		touchRight() {
			if(this.currSecurityIdx == 1){
        this.currSecurityIdx = this.securityDetails.length;
      }else{
        this.currSecurityIdx --
      }
		}
  },
};
</script>

<style scoped lang="less">
.hdcmpr_v2 {
  box-sizing: border-box;
  height: 722px;
  padding-top: 40px;
  background-color: rgb(245, 245, 247);
  .hdcmpr_title {
    margin: 0 auto;
    color: #000;
    font-family: PingFang SC;
    font-size: 26px;
    font-weight: 500;
    line-height: 54px;
    text-align: center;
    .protext {
      background: linear-gradient(153deg, #6F00FD 0%, #0046FB 31.89%, #00BDF9 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      -webkit-text-fill-color: transparent;
    }
  }
  .hdcmpr_subtitle {
    margin-top: 28px;
    color: #000;
    text-align: center;
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 400;
    line-height: normal;
  }
  .tabs_box {
    width: 254px;
    height: 32px;
    background-color: rgba(97, 99, 105, 0.15);
    user-select: none;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    border-radius: 20px;
    margin: 24px auto 0;
    &_1 {
      width: 102px;
    }
    &_2 {
      width: 126px;
    }
    &_1,
    &_2 {
      color: #616369;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
      text-align: center;
      z-index: 1;
      transition: color .3s;
      &.active {
        color: #ffffff;
      }
    }
    &_bg {
      position: absolute;
      left: 0;
      width: 102px;
      height: 100%;
      background: #000000;
      border-radius: 20px;
      transition: left 0.3s, width 0.3s;
      z-index: 0;
    }
  }
  .performance_wrap {
    .bg_Img {
      width: 280px;
      height: auto;
      display: block;
      margin: 17px auto 0;
    }
    .fun_list_wrap {
      box-sizing: border-box;
      padding-left: 15px;
      width: 280px;
      height: 164px;
      display: block;
      margin: 30px auto 0;
      .fun_item {
        margin-top: 16px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        color: #3A3A3A;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        svg {
          margin-right: 8px;
          flex-shrink: 0;
        }
        &:first-of-type {
          margin-top: 0;
        }
      }
    }
    .dl_btn {
      margin: 32px auto 0;
      width: 180px;
      height: 40px;
      border-radius: 6px;
      background-color: rgba(0, 112, 249, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 400;
      line-height: 1;
      letter-spacing: 0px;
      color: #fff;
      &:active {
        background-color: #1c87fd;
      }
    }
  }
  .security_wrap {
    min-height: 544px;
    position: relative;
    margin-top: 28px;
    touch-action: pan-y;
    .security_item {
      width: 100%;
      height: 330px;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: absolute;
      top: 0;
      opacity: 0;
      z-index: 0;
      &.active {
        opacity: 1;
      }
      .item_title {
        color: #000;
        text-align: center;
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 400;
        line-height: normal;
      }
      .item_subTitle {
        color: #000;
        text-align: center;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: 400;
        line-height: normal;
      }
      .item_bg_wrap {
        margin-top: 20px;
        width: 100%;
        height: 100%;;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        .bg_Img {
          width: 280px;
          height: auto;
          display: block;
        }
      }
      .item_desc {
        margin: 0 auto;
        width: 282px;
        height: 40px;
        overflow: visible;
        color: #3A3A3A;
        text-align: center;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
      }
    }
    .security_wrap_indicator {
      position: absolute;
      width: 100%;
      bottom: 174px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      .indicator_item {
        display: block;
        width: 8px;
        height: 8px;
        background-color: rgba(217, 217, 217, 1);
        border-radius: 50%;
        margin-right: 12px;
        &:last-of-type {
          margin-right: 0;
        }
        &.active {
          background-color: rgba(0, 112, 249, 1);
        }
      }
    }
  }
  .btn_wrap {
    position: absolute;
    bottom: 100px;
    display: flex;
    width: 100%;
    height: 40px;
    align-items: center;
    justify-content: center;
    .toc_dl {
      width: 133.5px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      background: #0070F9;
      color: #FFF;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 400;
      line-height: 1;
      margin-right: 16px;
      transition: background-color .2s;
      &:active {
        background: #1c87fd;
      }
    }
    .tob_register {
      width: 133.5px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      border: 1px solid #0070F9;
      background: transparent;
      color: #0070F9;
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 1;
      transition: all .2s;
      &:active {
        border: 1px solid #1c87fd;
        color: #1c87fd;
        background-color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
